export const TASK_STAGES = [
  ['todo', 'Новая'],
  ['in_progress', 'В работе'],
  ['review', 'На проверке'],
  ['done', 'Выполнена'],
];

export const TASK_STAGE_LABELS = Object.fromEntries(TASK_STAGES);

// Кто закрыл задачу (crm_tasks.closed_reason). Закрытие персоналом подписи
// не требует — это обычный случай; остальные два закрыла система.
export const TASK_CLOSED_REASON_LABELS = {
  guest_returned: 'закрыта системой: гость вернулся сам',
  archived: 'в архиве: вне правила авто-задач (топ-10% гостей, уход в риск)',
};
